// Where a game's randomness comes from.
//
// `src/engine/rules/` may not read a clock or call `Math.random` — two clients derive
// state from one log, so an unseeded roll is a desync. The way out has always
// been that the *caller* picks a seed and puts it in the opening command,
// where it travels with the game and replays exactly (PLAN §5.5).
//
// Nothing was picking one. `newGame` defaults to `seed = 0` and no launch path
// overrode it, so every run in the game's history rolled the same numbers: the
// same camp in the same place at every stage, the same drops off the same
// pieces, the same opening hand. All the machinery for unpredictable
// progression was there and being fed a constant.

/**
 * A fresh 32-bit seed.
 *
 * Both a clock read and a random draw, because either alone has a failure
 * mode worth avoiding: two tabs opened in the same millisecond would share a
 * timestamp, and `Math.random` is not required to differ across a page reload
 * in every engine. Mixed, and forced unsigned, because `streamFor` treats it
 * as an integer.
 */
export const freshSeed = (): number =>
  (Math.imul(Date.now() & 0xffffffff, 0x9e3779b1) ^ Math.floor(Math.random() * 0xffffffff)) >>> 0;
